import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid/Grid';
import { ICouponModel } from 'interfaces/ICouponModel';
import Button from '@material-ui/core/Button/Button';
import { SvgIcon } from 'components/SvgIcon';
import Fade from '@material-ui/core/Fade';
import { paymentService } from 'services/PaymentService';
import Translate from 'components/Translate';
import { cartService } from 'services/CartService';
import FieldText from 'components/Field/Text';
import { IProductData } from 'interfaces/IProductData';

const styles = require('./coupon.css');

interface IState extends IStateBase {
  cart: IProductData;
  model: ICouponModel;
  openForm: boolean;
  showBtnCoupon: boolean;
  showErrorMessage: boolean;
}

export default class Coupon extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      cart: null,
      model: null,
      openForm: false,
      showBtnCoupon: true,
      showErrorMessage: false
    };
  }

  componentDidMount() {
    this.bindModel(paymentService.getCoupon());
    this.observeState({ cart: null }, cartService.getCart());

    cartService.getCart()
      .bindComponent(this)
      .subscribe(cart => {
        if (cart.coupon) {
          this.setState({
            showBtnCoupon: false
          });
        }
      });
  }

  openCouponForm = () => {
    this.setState({
      openForm: true,
      showBtnCoupon: false,
    });
  }

  showBtnCoupon = () => {
    this.setState({
      openForm: false,
      showBtnCoupon: true
    });
  }

  showCode = () => {
    this.setState({
      openForm: false,
      showBtnCoupon: false,
    });

    setTimeout(() => {
      this.hideErrorMessage();
    }, 3000);
  }

  showErrorMessage = () => {
    this.setState({
      showErrorMessage: true
    });
  }

  hideErrorMessage = () => {
    this.setState({
      showErrorMessage: false
    });
  }

  setCoupon = () => {
    this.hideErrorMessage();

    const code = this.state.model.code;

    if (!code) {
      if (this.state.cart.coupon) {
        this.setState({
          openForm: false
        });

        return;
      }

      this.setState({
        showBtnCoupon: true,
        openForm: false
      });

      return;
    }

    cartService.setCoupon(code)
      .loader()
      .bindComponent(this)
      .subscribe(
        coupon => {
          this.setState({
            openForm: false
          });
        },
        err => {
          this.setState({
            showErrorMessage: true
          });

          setTimeout(() => {
            this.hideErrorMessage();
          }, 2000);
        });
  }

  removeCoupon = () => {
    cartService.removeCoupon()
      .loader()
      .bindComponent(this)
      .subscribe(
        coupon => {
          this.showBtnCoupon();
        }
      );
  }

  setCode = (code: any) => {
    this.setModel({ code });
  }

  handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      this.setCoupon();
    }
  }

  render() {

    const {
      cart,
      model,
      openForm,
      showBtnCoupon,
      showErrorMessage
    } = this.state;

    if (!cart || !cart.products[0].hasValidCoupons) {
      return null;
    }

    return (
      <div className={styles.component}>
        {openForm
          ? <Fade in={openForm}>
            <div className={'chk-coupon'}>
                <FieldText
                  id='code'
                  label={<Translate term='Código do cupom' />}
                  value={model.code || ''}
                  inputProps={{
                    className: 'theme-input field normal',
                    onKeyPress: this.handleKeyPress.bind(this)
                  }}
                  InputLabelProps={{
                    className: 'theme-label',
                    id: 'label-coupon'
                  }}
                  onChange={this.setCode}
                />
                <Button
                  id='chk-coupon-button'
                  variant='contained'
                  size='medium'
                  color='primary'
                  className='theme-button'
                  onClick={this.setCoupon}
                >
                  <SvgIcon name='checkIcon' />
                </Button>
            </div>
          </Fade>
          : cart.coupon && !showBtnCoupon
            ? <div>
              <h6 className='chk-coupon-code-label'><Translate term='Cupom adicionado:' /></h6>
              <Grid className={'chk-coupon chk-coupon-code-content'} container direction={'row'} alignItems={'center'}>
                <div className={'chk-coupon-code'}>
                  {cart.coupon.code}
                </div>
                <div className='chk-close theme-button' aria-label='Close' onClick={this.removeCoupon}>
                  <SvgIcon name='closeIcon' />
                </div>
              </Grid>
            </div>
            : showBtnCoupon
              ? <div onClick={this.openCouponForm} className='chk-button-coupon theme-label'>
                <Translate term='Cupom de Desconto?' />
              </div>
              : null
        }
        {showErrorMessage
          ? <span className={'chk-coupon-error'}>
            <Translate term='Cupom inválido ou inexistente' />
          </span>
          : null
        }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Coupon/index.tsx